import { inject, Service } from '@angular/core';
import { EventBusService } from '@shared';
import {
	HeaderConfigurationToHeader,
	HeaderSymbolToHeader,
	ORDER_FORM_HEADER_EVENTS
} from './order-form-header-events.model';

/**
 * Order Form → Header configuration producer.
 */
@Service({ autoProvided: false })
export class OrderFormHeaderEventProducerService {
	private readonly eventBus = inject(EventBusService);

	publishHeaderConfiguration(config?: HeaderConfigurationToHeader): void {
		this.eventBus.dispatch(ORDER_FORM_HEADER_EVENTS.HEADER_CONFIGURATION, config);
	}

	configureOrderFormHeader(symbol?: HeaderSymbolToHeader | null): void {
		this.publishHeaderConfiguration({
			showLogo: false,
			headerLeftSectionItems: [{ iconName: 'close', eventId: 'close', ariaLabel: 'بستن فرم سفارش' }],
			symbol: symbol ?? null
		});
	}

	resetHeader(): void {
		this.publishHeaderConfiguration();
	}

	clearEventSnapshot(eventId: string): void {
		this.eventBus.clearSnapshot(ORDER_FORM_HEADER_EVENTS.HEADER_ACTION, eventId);
	}
}
